import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postSendPasswordResetLink } from '../../../../../../api';

export const adminUsersByIdLinksPasswordResetPostSlice = createPostAsyncSlice({
	name: 'AdminUsersByIdLinksPasswordResetSend',
	receive: true,
	request: true,
	requestHandler: postSendPasswordResetLink,
	retainDataOnRequest: false
});
